import { reportClientError } from 'services/errorReportingService'
import { ERROR_REPORTED } from './actionConstants'
import { AnyAppAction } from './types/ActionTypes'

export function ReportError(error: Error | any, extras: any): AnyAppAction {
  return (dispatch) => {
    reportClientError(error, extras).then(errorId => {
      dispatch({ type: ERROR_REPORTED, errorId })
    })
  }
}
